
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
components: {
ButtonTab,
ButtonTabItem,
CellFormPreview,
Group,
Cell,
Tabbar,
TabbarItem
},

data() {
return {

option: 0,
data: []
}
},
computed: {},
created: function () {
document.title = '管理员'
this.getData();
},

methods: {
getData() {
this.$vux.loading.show('处理中');
this.$http.get(this.tianYiWebUrl + '/wechat/admin/static', {params: {type: this.option}}).then(res => {
this.data = res.data.data;
});
this.$vux.loading.hide();
}
},

watch: {
option: function () {
this.getData()
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/AdminStatic.vue